let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3YoR7")).then(() => parcelRequire('dvo9I'));